import { render } from "./moduleLibrary.vue?vue&type=template&id=2fd3ff4b"
import script from "./moduleLibrary.vue?vue&type=script&lang=js"
export * from "./moduleLibrary.vue?vue&type=script&lang=js"

import "./moduleLibrary.vue?vue&type=style&index=0&id=2fd3ff4b&lang=scss"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__